import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/products/nnp-vpn-logo-typo.svg")